import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menuGroups`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menuGroups`, payload);
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/menuGroups/${id}`);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/menuGroups/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/menuGroups/${id}`, payload);
};

const sort = (merchantId, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/menuGroupLinkCategorys/arrange`,
		payload
	);
};

const findMenuGroup = (merchantId, menuGroupCode) => {
	return Client.get(
		`${baseUrl}/${merchantId}/categorys/${menuGroupCode}/with-index`
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	sort,
	findMenuGroup,
};
